<style lang="scss" scoped>
.navbar {
    .offset {
        padding: 10px;
        @media only screen and (min-width: 768px) {
            padding: 10px 0 10px 60px;
            display: flex;
            flex-flow: row;
        }
        @media only screen and (max-width: 767px) {
            width: 100%;
            .hamburger {
                position: absolute;
                top: 20px;
                right: 0px;
                width: 40px;
                height: 12px;
                z-index: 202;
                cursor: pointer;
                margin-right: 3px;
                .one {
                    position: absolute;
                    width: 23px;
                    height: 3px;
                    background: #0f3261;
                }

                .two {
                    position: absolute;
                    width: 23px;
                    height: 3px;
                    background: #0f3261;
                    margin-top: 12px;
                }
            }
        }

        .nav-items {
            @media only screen and (max-width: 767px) {
                position: fixed;
                height: 0;
                z-index: 100;
                background: #fff;
                top: 52px;
                left: 0;
                display: flex;
                flex-flow: column;
                width: 100%;
                text-align: center;
                padding: 0 60px;
                overflow: hidden;
                transition: height 0.3s;
                .item {
                    margin: 30px auto;
                }
                &.open {
                    height: calc(100vh - 52px);
                    height: calc(var(--vh, 1vh) * 100 - 52px);
                }
            }
            @media only screen and (min-width: 768px) {
                margin: auto;
            }
        }
    }
    display: flex;
    flex-wrap: wrap;
    box-shadow: -6px 0 12px rgba(0, 0, 0, 0.06);
    .cushion {
        height: 32px;
        width: auto;
        margin-right: 30px;
        @media only screen and (min-width: 768px) {
            height: 48px;
        }
    }
    .item {
        line-height: 24px;
        margin: auto 20px;
        color: var(--dark);
        transition: box-shadow 0.3s;
        &.active {
            font-weight: 700;
            color: var(--primary-dark);
            box-shadow: 0px 35px 0px -10px var(--primary-dark);
        }
    }
    .item-large {
        background: var(--primary-dark);
        color: #fff;
        margin-left: auto;
        display: flex;
        align-items: center;
        padding: 0 30px;
    }
}
</style>

<template>
    <div class="navbar">

        <div class="offset">
            <router-link :to="{ name: 'admin-dashboard'}" active-class="active">
                <img class="cushion" src="/images/cushion.png" alt="Start to sleep">
            </router-link>

            <div class="hamburger d-md-none ml-auto" @click="mobileNavOpen = !mobileNavOpen">
                <span class="one"></span>
                <span class="two"></span>
            </div>

            <div class="nav-items" :class="{ open: mobileNavOpen}">
                <router-link :to="{ name: 'admin-dashboard'}" class="item" active-class="active">
                    {{ $t('navbar.dashboard') }}
                </router-link>

                <router-link v-if="currentUser.permissions.some((v) => ['medical_info.read', 'personal_info.read', 'sleep_info.read', 'sleep_schedule.read', 'habit.read'].indexOf(v) != -1 )  || (currentUser.psychologist && currentUser.psychologist.status === 'approved')" :to="{ name: 'admin-patients'}" class="item" active-class="active">
                    {{ $t('navbar.patients') }}
                </router-link>

                <router-link v-if="currentUser.permissions.includes('tip.read')" :to="{ name: 'admin-tips'}" class="item" active-class="active">
                    {{ $t('navbar.advice') }}
                </router-link>

                <router-link v-if="currentUser.permissions.includes('discount_code.read') /* || (currentUser.psychologist && currentUser.psychologist.status === 'approved') */" :to="{ name: 'admin-codes'}" class="item" active-class="active">
                    {{ $t('navbar.codes') }}
                </router-link>

                <router-link v-if="currentUser.permissions.includes('psychologist.read')" :to="{ name: 'admin-psychologists'}" class="item" active-class="active">
                    {{ $t('navbar.psychologists') }}
                </router-link>

                <router-link v-if="currentUser.permissions.includes('admin.read')" :to="{ name: 'admin-admins'}" class="item" active-class="active">
                    {{ $t('navbar.admins') }}
                </router-link>
            </div>
        </div>

        <div class="item-large  flex-column justify-content-center text-left d-none d-md-flex">
            <router-link :to="{ name: 'admin-profile'}" class="text-white mr-auto" active-class="active">
                {{ $t('navbar.my-profile') }}
            </router-link>
            <router-link :to="{ name: 'logout' }" class="text-white small mr-auto" active-class="active">
                {{ $t('sidebar.sign-off') }}
            </router-link>
        </div>
    </div>
</template>

<script>
export default {

    data: () => ({
        mobileNavOpen: false
    }),
    computed: {
        currentUser() {
            return this.$store.getters['user/currentUser']
        }
    }
}
</script>
  